import { queryOptions } from '@tanstack/react-query';
import { listTtFontWithFileAPI } from '@/service';

export const customFontsQueryOptions = queryOptions({
  queryKey: ['announcementCustomFontFaces'],
  queryFn: () => listTtFontWithFileAPI(),
  refetchOnMount: false,
});
